import { VIEW_COLUMNS } from './columns';

export const VIEW_FILTERS = {
  [VIEW_COLUMNS.ORDER_ID.id]: {
    ...VIEW_COLUMNS.ORDER_ID,
    filterable: true,
  },
  [VIEW_COLUMNS.SALES_ORDER_NUMBER.id]: {
    ...VIEW_COLUMNS.SALES_ORDER_NUMBER,
    filterable: true,
  },
  [VIEW_COLUMNS.SKU.id]: {
    ...VIEW_COLUMNS.SKU,
    filterable: true,
  },
  [VIEW_COLUMNS.UPC.id]: {
    ...VIEW_COLUMNS.UPC,
    filterable: true,
  },
  [VIEW_COLUMNS.PURCHASE_ORDER_NUMBER.id]: {
    ...VIEW_COLUMNS.PURCHASE_ORDER_NUMBER,
    filterable: true,
  },
  [VIEW_COLUMNS.QTY.id]: {
    ...VIEW_COLUMNS.QTY,
    filterable: true,
  },
  [VIEW_COLUMNS.PURCHASE_DATE.id]: {
    ...VIEW_COLUMNS.PURCHASE_DATE,
    filterable: true,
  },
  [VIEW_COLUMNS.RETURN_DATE.id]: {
    ...VIEW_COLUMNS.RETURN_DATE,
    filterable: true,
  },
  [VIEW_COLUMNS.BRAND.id]: {
    ...VIEW_COLUMNS.BRAND,
    filterable: true,
  },
  [VIEW_COLUMNS.SUPPLIER.id]: {
    ...VIEW_COLUMNS.SUPPLIER,
    filterable: true,
  },
  [VIEW_COLUMNS.SALES_CHANNEL.id]: {
    ...VIEW_COLUMNS.SALES_CHANNEL,
    filterable: true,
  },
  [VIEW_COLUMNS.NOTES.id]: {
    ...VIEW_COLUMNS.NOTES,
    filterable: false,
  },
  [VIEW_COLUMNS.REASON.id]: {
    ...VIEW_COLUMNS.REASON,
    filterable: true,
  },
  [VIEW_COLUMNS.ACTION.id]: {
    ...VIEW_COLUMNS.ACTION,
    filterable: true,
  }
};
